// extracted by mini-css-extract-plugin
export var aboutUs = "about-us-module--about-us--1b675";
export var author = "about-us-module--author--93b4e";
export var authorPreview = "about-us-module--author-preview--f166c";
export var banner = "about-us-module--banner--606c8";
export var category = "about-us-module--category--65c9b";
export var headline = "about-us-module--headline--4d41d";
export var headlinePost = "about-us-module--headline-post--67ea9";
export var paragraph = "about-us-module--paragraph--499f1";
export var seeAll = "about-us-module--see-all--de7ba";
export var teaser = "about-us-module--teaser--fa99f";
export var text = "about-us-module--text--17cb0";